export var ECardLinkSize = /* @__PURE__ */ ((ECardLinkSize2) => {
  ECardLinkSize2["Small"] = "SMALL";
  ECardLinkSize2["Large"] = "LARGE";
  return ECardLinkSize2;
})(ECardLinkSize || {});
export var ECardSizeMobile = /* @__PURE__ */ ((ECardSizeMobile2) => {
  ECardSizeMobile2["Small"] = "SMALL";
  ECardSizeMobile2["Large"] = "LARGE";
  return ECardSizeMobile2;
})(ECardSizeMobile || {});
export var ECardPhotoSizeDesktop = /* @__PURE__ */ ((ECardPhotoSizeDesktop2) => {
  ECardPhotoSizeDesktop2["Small"] = "SMALL";
  ECardPhotoSizeDesktop2["Large"] = "LARGE";
  ECardPhotoSizeDesktop2["XLarge"] = "XLARGE";
  ECardPhotoSizeDesktop2["XXLarge"] = "XXLARGE";
  ECardPhotoSizeDesktop2["Fluid"] = "FLUID";
  return ECardPhotoSizeDesktop2;
})(ECardPhotoSizeDesktop || {});
export var ECardSizeDesktop = /* @__PURE__ */ ((ECardSizeDesktop2) => {
  ECardSizeDesktop2["Small"] = "SMALL";
  ECardSizeDesktop2["Large"] = "LARGE";
  ECardSizeDesktop2["Fluid"] = "FLUID";
  return ECardSizeDesktop2;
})(ECardSizeDesktop || {});
export var ECardsListLayout = /* @__PURE__ */ ((ECardsListLayout2) => {
  ECardsListLayout2["Grid"] = "GRID";
  ECardsListLayout2["Carousel"] = "CAROUSEL";
  return ECardsListLayout2;
})(ECardsListLayout || {});
export var EButtonAlignment = /* @__PURE__ */ ((EButtonAlignment2) => {
  EButtonAlignment2["LEFT"] = "LEFT";
  EButtonAlignment2["RIGHT"] = "RIGHT";
  return EButtonAlignment2;
})(EButtonAlignment || {});
export var ESeoHeadingSize = /* @__PURE__ */ ((ESeoHeadingSize2) => {
  ESeoHeadingSize2["H1"] = "h1";
  ESeoHeadingSize2["H2"] = "h2";
  ESeoHeadingSize2["H3"] = "h3";
  ESeoHeadingSize2["H4"] = "h4";
  return ESeoHeadingSize2;
})(ESeoHeadingSize || {});
